import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="flex min-h-screen items-center justify-center bg-charcoal text-paper">
        <span className="text-sm tracking-mega uppercase text-teal-light">Loading…</span>
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
